import { SnackbarType } from 'common/interfaces';
import { IUserProfile } from 'common/interfaces/iprofile';
import { ProfileActions } from 'reducers/profile-reducer';
import { persistsUserData } from 'services/db-service';
import { ProfileService } from 'services/profile-service';
import { useAppDispatch } from 'setup/store';
import { useAppActions } from './app-actions';
import { useTranslation } from 'react-i18next';
import { AppStateController } from 'common/controller/AppStateController';

export const useProfileActions = () => {
  const dispatch = useAppDispatch();
  const { showSnackBar } = useAppActions();
  const { t } = useTranslation();

  const setLoading = async (isLoading: boolean) => {
    dispatch(ProfileActions.setLoading(isLoading));
  };

  const getUserProfile = async (refreshCache?: boolean) => {
    setLoading(true);
    const resp = await ProfileService.fetchUserProfileData(false, refreshCache || false);
    console.log('gotIUserProfile.....', resp);
    if (resp.status.success && resp.data?.user) {
      dispatch(ProfileActions.setUserProfile(resp.data.user));
      setLoading(false);
      if (resp.data.user.serverTimeDelta && Math.abs(resp.data.user.serverTimeDelta) > 0) {
        // setServerClockTimeDelta(resp.data.userData.serverTimeDelta);
        AppStateController.getInstance().setServerTimeDeltaInMillis(resp.data.user.serverTimeDelta);
      }
      return resp.data.user;
    } else {
      showSnackBar(SnackbarType.ERROR, resp?.status?.msg || t('profile.error.unableToLoadProfile') || '');
    }
    setLoading(false);
  };

  const updateUserProfile = async (profile: IUserProfile, displayPictureUri?: string) => {
    const resp = await ProfileService.postUserProfileUpdate(profile);
    if (resp.status.success) {
      showSnackBar(SnackbarType.SUCCESS, t('profile.msg.profileUpdate'));
      dispatch(ProfileActions.updateUserProfile(resp.data));
      persistsUserData(resp.data, 'localStorage');
    } else {
      showSnackBar(SnackbarType.ERROR, resp.status.msg || t('profile.error.unableToUpdateProfile') || '');
    }
    return resp;
  };

  const setUserProfile = (IuserProfile: IUserProfile) => {
    dispatch(ProfileActions.setUserProfile(IuserProfile));
  };
  const setError = (code: string, msg: string) => {
    dispatch(
      ProfileActions.setError(
        !msg
          ? {
              msg: msg || '',
              code: code || '',
            }
          : null,
      ),
    );
  };
  return {
    setLoading,
    setError,
    getUserProfile,
    updateUserProfile,
    setUserProfile,
  };
};
